import React, { useState, useLayoutEffect, useContext } from 'react';

import * as S from './styles';
import { tabsList } from './listTabsflag';
import AddBannersInList from 'components/AddBannersInList';
import DataFormCarouselBanners from 'components/DataFormCarouselBanners';
import TabsMaterial from 'components/TabsMaterial';
import { DataFormCarroselBannersProps } from 'types/DataFormCarroselBannersProps';
import DynamicPageContext from 'context/DynamicPage';
import { verifyIfFormCanSave } from './functions';

const initialData: DataFormCarroselBannersProps = {
	banners: [],
	paddingBottom: 0,
	paddingTop: 0,
	schedule: {
		countdown: false,
		end: '',
		start: '',
		timezone: 'America/Sao_Paulo'
	},
	title: '',
	type: ''
};

export default function InputsCarrosselBanner() {
	const {
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		setModuleOnPhoneToEdit,
		moduleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [tabSelected, setTabSelected] = useState(0);
	const [dataForm, setDataForm] = useState(initialData);

	useLayoutEffect(() => {
		const dataFormCopy = structuredClone(dataForm);

		if (
			dataFormCopy.schedule &&
			dataFormCopy.schedule?.start === '' &&
			dataFormCopy.schedule.end === ''
		) {
			dataFormCopy.schedule = initialData.schedule;
		}

		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataFormCopy };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataFormCopy };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(
			dataFormCopy,
			setCanSaveModuleOnBack,
			setMessageErrorForm
		);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}, 100);
		}
	}, []);

	return (
		<S.container>
			<TabsMaterial listTabs={tabsList} getPage={setTabSelected} />
			<S.content>
				<DataFormCarouselBanners
					isShow={tabSelected === 0}
					dataForm={dataForm}
					setDataForm={setDataForm}
				/>

				<AddBannersInList
					isShow={tabSelected === 1}
					dataForm={dataForm}
					setDataForm={setDataForm}
				/>
			</S.content>
		</S.container>
	);
}
